export default __webpack_public_path__ + "static/media/royalik.0afe8e43.png";